export default __webpack_public_path__ + "static/media/img9.2de4be02.png";